import { Button } from '~/components/component-library'
import { StepDone } from '~/components/post-onboarding-checklist/StepDone'

// The step completes when an invitee accepts, which can be much later than the
// invite. Say so, or sending one looks like it did nothing. Who was invited is
// deliberately left out: it reads the same for one invitee or five, and the
// members settings list the addresses alongside a way to revoke them.
export const WAITING_FOR_INVITATION = 'Waiting for them to join'

export const getTeammateStepMeta = ({
  isTeammateAdded,
  hasPendingInvitation,
  isOwner,
  openInviteDialog,
}: {
  isTeammateAdded: boolean
  hasPendingInvitation: boolean
  isOwner: boolean
  openInviteDialog: () => void
}) => {
  if (isTeammateAdded) return <StepDone />
  if (hasPendingInvitation) return undefined
  return (
    <Button
      variant="secondary"
      size="small"
      isDisabled={!isOwner}
      disabledReason="Only workspace owners can invite members"
      onClick={openInviteDialog}
    >
      Invite
    </Button>
  )
}
